import React from 'react';
import TokenAmount from './TokenAmount';
import { useCSS } from '../../../lib/hooks';

const TokensWallet = ({ tokens, totals, ...props }) => {
	useCSS('comp/prize_gallery.css');
	
	if(tokens == undefined) return null;

	return (
		<div class="tokens_wallet">
			{Object.values(tokens).map((_token) => {
				const token = _token?.LoyaltyToken ?? _token;
				const _id = token.id;
				let actual_tokens = 0;
				if(totals[token.id] != undefined) actual_tokens = totals[_id];

				return (
					<TokenAmount
						key={`tw_${_id}`}
						token={token}
						amount={actual_tokens}
						type={props?.type ?? 'wallet'}
						link_props={props.link_props}
						locale={props.locale}
					/>
				)
			})}
		</div>
	)
};

export default TokensWallet;